export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const RESET_AVAILABLE_CLIENTS = 'RESET_AVAILABLE_CLIENTS';
export const SET_USER_ROLES = 'SET_USER_ROLES';
export const SET_AVAILABLE_CLIENTS = 'SET_AVAILABLE_CLIENTS';
